import StaffListView from "./StaffListView";

const StaffListWrapper = () => {
  return <StaffListView />;
};
export default StaffListWrapper;
